/* esm.sh - fflate@0.8.3 */
export * from "/*fflate@0.8.3/esnext/fflate.mjs";
